module.exports = __webpack_public_path__ + "img/user-data-bg.51215256.png";